import { render, staticRenderFns } from "./ExceptAreaPage.vue?vue&type=template&id=21e1e920&scoped=true&"
import script from "./ExceptAreaPage.vue?vue&type=script&lang=js&"
export * from "./ExceptAreaPage.vue?vue&type=script&lang=js&"
import style0 from "./ExceptAreaPage.vue?vue&type=style&index=0&id=21e1e920&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e1e920",
  null
  
)

export default component.exports